// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Z1Z1K{margin-top:var(--unit);padding-bottom:0}", "",{"version":3,"sources":["webpack://./src/components/molecules/showMoreButton/showMoreButton.module.scss"],"names":[],"mappings":"AAAA,OACI,sBAAA,CACA,gBAAA","sourcesContent":[".show-more {\n    margin-top: var(--unit);\n    padding-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"show-more": "Z1Z1K",
	"showMore": "Z1Z1K"
};
export default ___CSS_LOADER_EXPORT___;
